import React from 'react';
import ilustracionConceptoLibro from '../../img/ilustracion-concepto-libro-contabilidad_1237743-80074.jpg';

const ToolsSection = () => {
  const tools = [
    {
      title: 'Explorador de Propósito y Proyecto de Vida',
      description: 'Una herramienta para reconocer tu momento actual, tus metas y lo que te mueve a actuar.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg>
      )
    },
    {
      title: 'Mapa Personal de Bienestar Emocional',
      description: 'Explora cómo estás hoy en relación con tus emociones, hábitos y decisiones cotidianas. Una herramienta formativa para fortalecer tu bienestar emocional y orientar acciones de autocuidado y apoyo.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21a9 9 0 1 0-9-9c0 1.488.504 2.853 1.338 3.937"></path><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path><path d="M12 15a3 3 0 0 1-3-3"></path></svg>
      )
    },
    {
      title: 'Rueda de la Vida',
      description: 'Obtén una visión panorámica de tu realidad actual. Visualiza el equilibrio entre tus áreas vitales e identifica dónde iniciar el cambio.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7.5" r="4.5"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line></svg>
      )
    }
  ];

  return (
    <section className="py-[80px] px-5 max-md:py-[40px]">
      <div className="max-w-[1100px] mx-auto px-5">
        {/* Header */}
        <div className="flex items-center justify-between gap-[40px] mb-[60px] max-md:flex-col max-md:text-center">
          <div className="flex-1 text-left max-w-[50%] max-md:max-w-full max-md:mb-[30px]">
            <h2 className="text-texto-oscuro font-extrabold uppercase relative text-[2.8rem] m-0 mb-[15px] leading-[1.2] pb-[10px] max-md:text-[2.1rem] max-md:text-center">
              Herramientas de Autodiagnóstico
              <span className="absolute bottom-0 left-0 bg-icetex w-[70px] h-[4px] rounded-[2px] max-md:left-1/2 max-md:-translate-x-1/2"></span>
            </h2>
            <p className="text-texto-sec text-[1.1rem] leading-[1.7] m-0 max-md:text-base">
              Con nuestras herramientas de autodiagnóstico podrás conocerte mejor y recibir un plan de recomendaciones personalizadas.
            </p>
          </div>
          <div className="basis-[40%] text-center max-md:mb-[30px]">
            <img src={ilustracionConceptoLibro} alt="Ilustración de libro y contabilidad" className="max-w-full h-auto max-h-[220px]" />
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-[30px] mb-[50px] justify-center max-md:gap-5">
          {tools.map((tool, index) => (
            <div
              key={index}
              className="bg-fondo-claro text-left flex flex-col h-full p-[35px] rounded-[15px] border border-[#e0e5f0] transition-all duration-300 ease-in-out hover:border-icetex hover:-translate-y-[8px] hover:shadow-[0_12px_30px_rgba(0,0,0,0.1)] max-md:p-[25px]"
            >
              <div className="bg-icetex text-white flex items-center justify-center w-[50px] h-[50px] mb-5 rounded-[10px] [&_svg]:w-[28px] [&_svg]:h-[28px]">
                {tool.icon}
              </div>
              <h3 className="text-texto-oscuro font-bold text-[1.3rem] mb-[10px]">{tool.title}</h3>
              <p className="text-texto-sec text-[0.95rem] leading-[1.6]">{tool.description}</p>
            </div>
          ))}
        </div>

        <a
          href="/diagnosticos"
          className="bg-icetex text-white border-0 uppercase font-bold cursor-pointer no-underline text-center py-[15px] px-[35px] rounded-[50px] text-base tracking-[0.5px] shadow-[0_4px_15px_rgba(0,63,129,0.3)] block w-fit mx-auto transition-all duration-300 hover:text-white hover:bg-texto-oscuro hover:-translate-y-[3px] max-md:w-full max-md:max-w-[350px] max-md:px-[30px]"
        >
          Comienza tu autodiagnóstico
        </a>
      </div>
    </section>
  );
};

export default ToolsSection;
